interface IObject {
  [key: string]: any;
}
export const ROLES = {
  USER: "unassigned",
  APP_USER: "appUser",
  NAMESPACE: "namespaceDeveloper",
  WORKSPACE_OWNER: "workspaceOwner",
  CLUSTER_OWNER: "clusterOwner",
  CLUSTER_ADMIN: "clusterAdmin",
  GLOBAL_ADMIN: "globalAdmin",
  SUBSCRIPTION_ADMIN: "subscriptionAdmin",
  SUBSCRIPTION_USER: "subscriptionUser",
};

export const ROLES_LEVEL = [
  [ROLES.USER, ROLES.APP_USER],
  [ROLES.USER, ROLES.APP_USER, ROLES.NAMESPACE],
  [ROLES.USER, ROLES.APP_USER, ROLES.NAMESPACE, ROLES.WORKSPACE_OWNER],
  [ROLES.USER, ROLES.APP_USER, ROLES.NAMESPACE, ROLES.WORKSPACE_OWNER, ROLES.CLUSTER_OWNER, ROLES.CLUSTER_ADMIN],
  [ROLES.USER, ROLES.APP_USER, ROLES.NAMESPACE, ROLES.WORKSPACE_OWNER, ROLES.CLUSTER_OWNER, ROLES.CLUSTER_ADMIN, ROLES.GLOBAL_ADMIN],
];

export const USER_URL: IObject = {
  management: "/esm/user-management",
  myProfile: "/user/myProfile",
  subscription: "/user/subscription",
  costCenter: "/user/costCenter",
  roles: "/user/roles",
  changepwd: "/user/changepwd",
  editProfile: "/esm/user-edit-profile",
  editMyProfile: "/user/editMyProfile",
  editSubProfile: "/user/editSubProfile",
  groupsDetail: "/user/groupsDetail",
  groupsDetailEdit: "/user/groupsDetailEdit",
  clientManagement: "/user/clientManagement",
  clientCreation: "/user/clientCreation",
  clientMgmtCreation: "/user/clientMgmtCreation",
  clientEdit: "/user/clientEdit",
  clientCreationSuccess: "/user/clientCreationSuccess",
  clientCreationNormalSuccess: "/user/clientCreationNormalSuccess",
  setting: "/user/setting",
};

export const url_relation: IObject = {
  subscriptionManagement: [USER_URL.subscription],
  subscriptionUser: [USER_URL.groupsDetail, USER_URL.groupsDetailEdit, USER_URL.editSubProfile],
  userManagement: [USER_URL.management, USER_URL.editProfile],
  myProfile: [USER_URL.myProfile, USER_URL.editMyProfile, USER_URL.changepwd],
  costCenter: [USER_URL.costCenter],
  clientManagement: [USER_URL.clientManagement, USER_URL.clientMgmtCreation, USER_URL.clientEdit, USER_URL.clientCreationSuccess],
  clientCreation: [USER_URL.clientCreation, USER_URL.clientCreationNormalSuccess],
  roles: [USER_URL.roles],
  setting: [USER_URL.setting],
};

export const match_param = (search: string, name: string) => {
  search = search.substr(1);
  const matchReg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const matchRes = search.match(matchReg);
  return matchRes ? unescape(matchRes[2]) : null;
};

export const USER_INTERFACE = {
  USER: "/v1/user",
  USERS: "/v1/users",
  USER_SSO: "/v4.0/user",
  USERS_SSO: "/v4.0/users",
};

export const user_left_menu = [
  {
    i18n: "subscription",
    key: "subscriptionMgmt",
    sub_menu: [
      {
        i18n: "management",
        key: "subscriptionManagement",
        url: USER_URL.subscription,
      },
      {
        i18n: "subscription_user",
        key: "subscriptionUser",
        url: USER_URL.groupsDetail,
      },
    ],
    url: USER_URL.subscription,
    refuse: ROLES_LEVEL[3],
    allow: [ROLES.SUBSCRIPTION_ADMIN, ROLES.SUBSCRIPTION_USER],
  },
  {
    i18n: "resources_permission",
    key: "userManagement",
    url: USER_URL.management,
    refuse: ROLES_LEVEL[1],
  },
  {
    i18n: "clients",
    key: "client",
    sub_menu: [
      {
        i18n: "management",
        key: "clientManagement", // key须和url最后一部分相同
        url: USER_URL.clientManagement,
        refuse: ROLES_LEVEL[1],
      },
      {
        i18n: "creation",
        key: "clientCreation",
        url: USER_URL.clientCreation,
        state: { src: "normal" },
      },
    ],
  },
  {
    i18n: "my_profile",
    key: "myProfile",
    url: USER_URL.myProfile,
  },
  // {
  //     i18n: 'cost_center',
  //     key: 'costCenter',
  //     url: USER_URL.costCenter,
  //     refuse: ROLES_LEVEL[4],
  // },
  {
    i18n: "roles_introduction",
    key: "roles",
    url: USER_URL.roles,
  },
  {
    i18n: "setting",
    key: "setting",
    url: USER_URL.setting,
  },
];

// formatDate(0, 'yyyy/MM/dd HH:mm:ss')
export const formatDate = function (date: number = 0, fmt: string = "yyyy/MM/dd HH:mm:ss") {
  if (0 === date) {
    return "";
  }
  date *= 1000;
  const current_date = new Date(date);
  let o: any = {
    "M+": current_date.getMonth() + 1,
    "d+": current_date.getDate(),
    "H+": current_date.getHours(),
    "m+": current_date.getMinutes(),
    "s+": current_date.getSeconds(),
    "S+": current_date.getMilliseconds(),
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (current_date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(String(o[k]).length));
    }
  }
  return fmt;
};

export const isEffective = (value: any) => {
  if (
    typeof value === "undefined" ||
    value === null ||
    value === "" ||
    (typeof value === "object" && JSON.stringify(value) === "{}") ||
    (Array.isArray(value) && value.length === 0)
  ) {
    return false;
  }
  return true;
};

export const fetchGet = (url: string, method: string = "Get", body: any, token: string) => {
  const init: RequestInit = {
    method,
    headers: {
      Authorization: `Bearer ${
        token ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJDbHVzdGVyIjoibG9jYWwiLCJVc2VyIjoiNGFhYTE1OTYtYmEyZi00ZjViLWE3M2YtNmU1MzdjOTVkMDZhIn0.MM427GY7lrEEWFklrblDQAAqlNfNm5pKdc3qrmAf50o"
      }`,
      "Content-Type": "application/json",
    },
  };
  if (body) {
    init.body = JSON.stringify(body);
  }
  return fetch(window.location.origin + url, init);
};

export const guid = () => {
  const S4 = () => {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
};

export const isObject = (obj: any) => {
  return Object.prototype.toString.call(obj) === "[object Object]";
};

export const all_option_modal = (value: string) => {
  return { id: guid(), name: value };
};

export const all_option_modal_2 = (value: string) => {
  return { id: value, name: value };
};

export const parse_option_data = (data: any) => {
  return data.map((item: any) => ({
    key: item.id || item.name,
    value: item.name,
    text: item.name,
  }));
};
export const parse_w_option_data = (data: any) => {
  return data.map((item: any) => ({
    key: item.id,
    value: item.id,
    text: item.name,
  }));
};
export const format_option_data = (data: any) => {
  return data.map((item: any) => ({
    // key: item.metadata.uid,
    // value: item.metadata.name,
    // text: item.metadata.name,
    key: item,
    value: item,
    text: item,
  }));
};
// datacenter cluster workspace 的名称从labels里取， id 从name里取
export const format_option_data_2 = (data: any) => {
  return data.map((item: any) => ({
    key: item.metadata.uid,
    value: item.metadata.name,
    text: item.metadata.labels.name,
  }));
};

export const openPage = (link: any) => {
  window.open(`//${link}`, "_blank");
};
export const openNewPage = (link: any) => {
  window.open(link, "_blank");
};

// rolebinding时MP需要kebab，展示时和sso时需要camel，所以转换
export const parse_to_camel = (text: string) => {
  if (text.includes("-")) {
    const text_arr = text.split("-");
    return text_arr[0] + text_arr[1].replace(text_arr[1][0], text_arr[1][0].toUpperCase());
  }
  return text;
};

export const parse_to_kebab = (text: string) => {
  const upper_reg = /[A-Z]/;
  const match_res = text.match(upper_reg);
  if (match_res) {
    const letter = match_res[0];
    const text_arr = text.split(letter);
    return `${text_arr[0]}-${letter.toLowerCase()}${text_arr[1]}`;
  }
  return text;
};

export const country_code = [
  {
    name_en: "Angola",
    name_zh: "安哥拉",
    country_code: "AO",
    phone_perfix: "244",
  },
  {
    name_en: "Afghanistan",
    name_zh: "阿富汗",
    country_code: "AF",
    phone_perfix: "9",
  },
  {
    name_en: "Albania",
    name_zh: "阿尔巴尼亚",
    country_code: "AL",
    phone_perfix: "355",
  },
  {
    name_en: "Algeria",
    name_zh: "阿尔及利亚",
    country_code: "DZ",
    phone_perfix: "213",
  },
  {
    name_en: "Andorra",
    name_zh: "安道尔共和国",
    country_code: "AD",
    phone_perfix: "376",
  },
  {
    name_en: "Anguilla",
    name_zh: "安圭拉岛",
    country_code: "AI",
    phone_perfix: "1264",
  },
  {
    name_en: "Antigua and Barbuda",
    name_zh: "安提瓜和巴布达",
    country_code: "AG",
    phone_perfix: "1268",
  },
  {
    name_en: "Argentina",
    name_zh: "阿根廷",
    country_code: "AR",
    phone_perfix: "54",
  },
  {
    name_en: "Armenia",
    name_zh: "亚美尼亚",
    country_code: "AM",
    phone_perfix: "374",
  },
  {
    name_en: "Ascension",
    name_zh: "阿森松",
    country_code: "AC",
    phone_perfix: "247",
  },
  {
    name_en: "Australia",
    name_zh: "澳大利亚",
    country_code: "AU",
    phone_perfix: "61",
  },
  {
    name_en: "Austria",
    name_zh: "奥地利",
    country_code: "AT",
    phone_perfix: "43",
  },
  {
    name_en: "Azerbaijan",
    name_zh: "阿塞拜疆",
    country_code: "AZ",
    phone_perfix: "994",
  },
  {
    name_en: "Bahamas",
    name_zh: "巴哈马",
    country_code: "BS",
    phone_perfix: "1242",
  },
  {
    name_en: "Bahrain",
    name_zh: "巴林",
    country_code: "BH",
    phone_perfix: "973",
  },
  {
    name_en: "Bangladesh",
    name_zh: "孟加拉国",
    country_code: "BD",
    phone_perfix: "880",
  },
  {
    name_en: "Barbados",
    name_zh: "巴巴多斯",
    country_code: "BB",
    phone_perfix: "1246",
  },
  {
    name_en: "Belarus",
    name_zh: "白俄罗斯",
    country_code: "BY",
    phone_perfix: "375",
  },
  {
    name_en: "Belgium",
    name_zh: "比利时",
    country_code: "BE",
    phone_perfix: "32",
  },
  {
    name_en: "Belize",
    name_zh: "伯利兹",
    country_code: "BZ",
    phone_perfix: "501",
  },
  {
    name_en: "Benin",
    name_zh: "贝宁",
    country_code: "BJ",
    phone_perfix: "229",
  },
  {
    name_en: "Bermuda Is.",
    name_zh: "百慕大群岛",
    country_code: "BM",
    phone_perfix: "1441",
  },
  {
    name_en: "Bolivia",
    name_zh: "玻利维亚",
    country_code: "BO",
    phone_perfix: "591",
  },
  {
    name_en: "Botswana",
    name_zh: "博茨瓦纳",
    country_code: "BW",
    phone_perfix: "267",
  },
  {
    name_en: "Brazil",
    name_zh: "巴西",
    country_code: "BR",
    phone_perfix: "55",
  },
  {
    name_en: "Brunei",
    name_zh: "文莱",
    country_code: "BN",
    phone_perfix: "67",
  },
  {
    name_en: "Bulgaria",
    name_zh: "保加利亚",
    country_code: "BG",
    phone_perfix: "359",
  },
  {
    name_en: "Burkina-faso",
    name_zh: "布基纳法索",
    country_code: "BF",
    phone_perfix: "226",
  },
  {
    name_en: "Burma",
    name_zh: "缅甸",
    country_code: "MM",
    phone_perfix: "95",
  },
  {
    name_en: "Burundi",
    name_zh: "布隆迪",
    country_code: "BI",
    phone_perfix: "257",
  },
  {
    name_en: "Cameroon",
    name_zh: "喀麦隆",
    country_code: "CM",
    phone_perfix: "237",
  },
  {
    name_en: "Canada",
    name_zh: "加拿大",
    country_code: "CA",
    phone_perfix: "1",
  },
  {
    name_en: "Cayman Is.",
    name_zh: "开曼群岛",
    country_code: "KY",
    phone_perfix: "1345",
  },
  {
    name_en: "Central African Republic",
    name_zh: "中非共和国",
    country_code: "CF",
    phone_perfix: "236",
  },
  {
    name_en: "Chad",
    name_zh: "乍得",
    country_code: "TD",
    phone_perfix: "235",
  },
  {
    name_en: "Chile",
    name_zh: "智利",
    country_code: "CL",
    phone_perfix: "56",
  },
  {
    name_en: "China",
    name_zh: "中国",
    country_code: "CN",
    phone_perfix: "86",
  },
  {
    name_en: "Colombia",
    name_zh: "哥伦比亚",
    country_code: "CO",
    phone_perfix: "5",
  },
  {
    name_en: "Congo",
    name_zh: "刚果",
    country_code: "CG",
    phone_perfix: "242",
  },
  {
    name_en: "Cook Is.",
    name_zh: "库克群岛",
    country_code: "CK",
    phone_perfix: "682",
  },
  {
    name_en: "Costa Rica",
    name_zh: "哥斯达黎加",
    country_code: "CR",
    phone_perfix: "506",
  },
  {
    name_en: "Cuba",
    name_zh: "古巴",
    country_code: "CU",
    phone_perfix: "53",
  },
  {
    name_en: "Cyprus",
    name_zh: "塞浦路斯",
    country_code: "CY",
    phone_perfix: "357",
  },
  {
    name_en: "Czech",
    name_zh: "捷克",
    country_code: "CZ",
    phone_perfix: "420",
  },
  {
    name_en: "Denmark",
    name_zh: "丹麦",
    country_code: "DK",
    phone_perfix: "45",
  },
  {
    name_en: "Djibouti",
    name_zh: "吉布提",
    country_code: "DJ",
    phone_perfix: "253",
  },
  {
    name_en: "Dominica Rep.",
    name_zh: "多米尼加共和国",
    country_code: "DO",
    phone_perfix: "1890",
  },
  {
    name_en: "Ecuador",
    name_zh: "厄瓜多尔",
    country_code: "EC",
    phone_perfix: "593",
  },
  {
    name_en: "Egypt",
    name_zh: "埃及",
    country_code: "EG",
    phone_perfix: "20",
  },
  {
    name_en: "EI Salvador",
    name_zh: "萨尔瓦多",
    country_code: "SV",
    phone_perfix: "503",
  },
  {
    name_en: "Estonia",
    name_zh: "爱沙尼亚",
    country_code: "EE",
    phone_perfix: "372",
  },
  {
    name_en: "Ethiopia",
    name_zh: "埃塞俄比亚",
    country_code: "ET",
    phone_perfix: "251",
  },
  {
    name_en: "Fiji",
    name_zh: "斐济",
    country_code: "FJ",
    phone_perfix: "679",
  },
  {
    name_en: "Finland",
    name_zh: "芬兰",
    country_code: "FI",
    phone_perfix: "358",
  },
  {
    name_en: "France",
    name_zh: "法国",
    country_code: "FR",
    phone_perfix: "33",
  },
  {
    name_en: "French Guiana",
    name_zh: "法属圭亚那",
    country_code: "GF",
    phone_perfix: "594",
  },
  {
    name_en: "Gabon",
    name_zh: "加蓬",
    country_code: "GA",
    phone_perfix: "241",
  },
  {
    name_en: "Gambia",
    name_zh: "冈比亚",
    country_code: "GM",
    phone_perfix: "220",
  },
  {
    name_en: "Georgia",
    name_zh: "格鲁吉亚",
    country_code: "GE",
    phone_perfix: "99",
  },
  {
    name_en: "Germany",
    name_zh: "德国",
    country_code: "DE",
    phone_perfix: "49",
  },
  {
    name_en: "Ghana",
    name_zh: "加纳",
    country_code: "GH",
    phone_perfix: "233",
  },
  {
    name_en: "Gibraltar",
    name_zh: "直布罗陀",
    country_code: "GI",
    phone_perfix: "350",
  },
  {
    name_en: "Greece",
    name_zh: "希腊",
    country_code: "GR",
    phone_perfix: "30",
  },
  {
    name_en: "Grenada",
    name_zh: "格林纳达",
    country_code: "GD",
    phone_perfix: "1809",
  },
  {
    name_en: "Guam",
    name_zh: "关岛",
    country_code: "GU",
    phone_perfix: "1671",
  },
  {
    name_en: "Guatemala",
    name_zh: "危地马拉",
    country_code: "GT",
    phone_perfix: "502",
  },
  {
    name_en: "Guinea",
    name_zh: "几内亚",
    country_code: "GN",
    phone_perfix: "224",
  },
  {
    name_en: "Guyana",
    name_zh: "圭亚那",
    country_code: "GY",
    phone_perfix: "592",
  },
  {
    name_en: "Haiti",
    name_zh: "海地",
    country_code: "HT",
    phone_perfix: "509",
  },
  {
    name_en: "Honduras",
    name_zh: "洪都拉斯",
    country_code: "HN",
    phone_perfix: "504",
  },
  {
    name_en: "Hongkong",
    name_zh: "香港",
    country_code: "HK",
    phone_perfix: "85",
  },
  {
    name_en: "Hungary",
    name_zh: "匈牙利",
    country_code: "HU",
    phone_perfix: "36",
  },
  {
    name_en: "Iceland",
    name_zh: "冰岛",
    country_code: "IS",
    phone_perfix: "354",
  },
  {
    name_en: "India",
    name_zh: "印度",
    country_code: "IN",
    phone_perfix: "91 -",
  },
  {
    name_en: "Indonesia",
    name_zh: "印度尼西亚",
    country_code: "ID",
    phone_perfix: "62",
  },
  {
    name_en: "Iran",
    name_zh: "伊朗",
    country_code: "IR",
    phone_perfix: "98 -",
  },
  {
    name_en: "Iraq",
    name_zh: "伊拉克",
    country_code: "IQ",
    phone_perfix: "964",
  },
  {
    name_en: "Ireland",
    name_zh: "爱尔兰",
    country_code: "IE",
    phone_perfix: "353",
  },
  {
    name_en: "Israel",
    name_zh: "以色列",
    country_code: "IL",
    phone_perfix: "972",
  },
  {
    name_en: "Italy",
    name_zh: "意大利",
    country_code: "IT",
    phone_perfix: "39",
  },
  {
    name_en: "Ivory Coast",
    name_zh: "科特迪瓦",
    country_code: "KT",
    phone_perfix: "225",
  },
  {
    name_en: "Jamaica",
    name_zh: "牙买加",
    country_code: "JM",
    phone_perfix: "1876",
  },
  {
    name_en: "Japan",
    name_zh: "日本",
    country_code: "JP",
    phone_perfix: "81",
  },
  {
    name_en: "Jordan",
    name_zh: "约旦",
    country_code: "JO",
    phone_perfix: "962",
  },
  {
    name_en: "Kampuchea （Cambodia）",
    name_zh: "柬埔寨",
    country_code: "KH",
    phone_perfix: "855",
  },
  {
    name_en: "Kazakstan",
    name_zh: "哈萨克斯坦",
    country_code: "KZ",
    phone_perfix: "327",
  },
  {
    name_en: "Kenya",
    name_zh: "肯尼亚",
    country_code: "KE",
    phone_perfix: "254",
  },
  {
    name_en: "Korea",
    name_zh: "韩国",
    country_code: "KR",
    phone_perfix: "82",
  },
  {
    name_en: "Kuwait",
    name_zh: "科威特",
    country_code: "KW",
    phone_perfix: "965",
  },
  {
    name_en: "Kyrgyzstan",
    name_zh: "吉尔吉斯坦",
    country_code: "KG",
    phone_perfix: "331",
  },
  {
    name_en: "Laos",
    name_zh: "老挝",
    country_code: "LA",
    phone_perfix: "856",
  },
  {
    name_en: "Latvia",
    name_zh: "拉脱维亚",
    country_code: "LV",
    phone_perfix: "371",
  },
  {
    name_en: "Lebanon",
    name_zh: "黎巴嫩",
    country_code: "LB",
    phone_perfix: "961",
  },
  {
    name_en: "Lesotho",
    name_zh: "莱索托",
    country_code: "LS",
    phone_perfix: "266",
  },
  {
    name_en: "Liberia",
    name_zh: "利比里亚",
    country_code: "LR",
    phone_perfix: "231",
  },
  {
    name_en: "Libya",
    name_zh: "利比亚",
    country_code: "LY",
    phone_perfix: "218",
  },
  {
    name_en: "Liechtenstein",
    name_zh: "列支敦士登",
    country_code: "LI",
    phone_perfix: "423",
  },
  {
    name_en: "Lithuania",
    name_zh: "立陶宛",
    country_code: "LT",
    phone_perfix: "370",
  },
  {
    name_en: "Luxembourg",
    name_zh: "卢森堡",
    country_code: "LU",
    phone_perfix: "352",
  },
  {
    name_en: "Macao",
    name_zh: "澳门",
    country_code: "MO",
    phone_perfix: "85",
  },
  {
    name_en: "Madagascar",
    name_zh: "马达加斯加",
    country_code: "MG",
    phone_perfix: "261",
  },
  {
    name_en: "Malawi",
    name_zh: "马拉维",
    country_code: "MW",
    phone_perfix: "265",
  },
  {
    name_en: "Malaysia",
    name_zh: "马来西亚",
    country_code: "MY",
    phone_perfix: "60",
  },
  {
    name_en: "Maldives",
    name_zh: "马尔代夫",
    country_code: "MV",
    phone_perfix: "960",
  },
  {
    name_en: "Mali",
    name_zh: "马里",
    country_code: "ML",
    phone_perfix: "223",
  },
  {
    name_en: "Malta",
    name_zh: "马耳他",
    country_code: "MT",
    phone_perfix: "356",
  },
  {
    name_en: "Martinique",
    name_zh: "马提尼克",
    country_code: "MQ",
    phone_perfix: "596",
  },
  {
    name_en: "Mauritius",
    name_zh: "毛里求斯",
    country_code: "MU",
    phone_perfix: "230",
  },
  {
    name_en: "Mexico",
    name_zh: "墨西哥",
    country_code: "MX",
    phone_perfix: "52",
  },
  {
    name_en: "Moldova",
    name_zh: "摩尔多瓦",
    country_code: "MD",
    phone_perfix: "373",
  },
  {
    name_en: "Monaco",
    name_zh: "摩纳哥",
    country_code: "MC",
    phone_perfix: "377",
  },
  {
    name_en: "Mongolia",
    name_zh: "蒙古",
    country_code: "MN",
    phone_perfix: "97",
  },
  {
    name_en: "Montserrat Is.",
    name_zh: "蒙特塞拉特岛",
    country_code: "MS",
    phone_perfix: "1664",
  },
  {
    name_en: "Morocco",
    name_zh: "摩洛哥",
    country_code: "MA",
    phone_perfix: "212",
  },
  {
    name_en: "Mozambique",
    name_zh: "莫桑比克",
    country_code: "MZ",
    phone_perfix: "258",
  },
  {
    name_en: "Namibia",
    name_zh: "纳米比亚",
    country_code: "NA",
    phone_perfix: "264",
  },
  {
    name_en: "Nauru",
    name_zh: "瑙鲁",
    country_code: "NR",
    phone_perfix: "674",
  },
  {
    name_en: "Nepal",
    name_zh: "尼泊尔",
    country_code: "NP",
    phone_perfix: "977",
  },
  {
    name_en: "Netheriands Antilles",
    name_zh: "荷属安的列斯",
    country_code: "AN",
    phone_perfix: "599",
  },
  {
    name_en: "Netherlands",
    name_zh: "荷兰",
    country_code: "NL",
    phone_perfix: "31",
  },
  {
    name_en: "New Zealand",
    name_zh: "新西兰",
    country_code: "NZ",
    phone_perfix: "64",
  },
  {
    name_en: "Nicaragua",
    name_zh: "尼加拉瓜",
    country_code: "NI",
    phone_perfix: "505",
  },
  {
    name_en: "Niger",
    name_zh: "尼日尔",
    country_code: "NE",
    phone_perfix: "227",
  },
  {
    name_en: "Nigeria",
    name_zh: "尼日利亚",
    country_code: "NG",
    phone_perfix: "234",
  },
  {
    name_en: "North Korea",
    name_zh: "朝鲜",
    country_code: "KP",
    phone_perfix: "850",
  },
  {
    name_en: "Norway",
    name_zh: "挪威",
    country_code: "NO",
    phone_perfix: "47",
  },
  {
    name_en: "Oman",
    name_zh: "阿曼",
    country_code: "OM",
    phone_perfix: "968",
  },
  {
    name_en: "Pakistan",
    name_zh: "巴基斯坦",
    country_code: "PK",
    phone_perfix: "92",
  },
  {
    name_en: "Panama",
    name_zh: "巴拿马",
    country_code: "PA",
    phone_perfix: "507",
  },
  {
    name_en: "Papua New Cuinea",
    name_zh: "巴布亚新几内亚",
    country_code: "PG",
    phone_perfix: "675",
  },
  {
    name_en: "Paraguay",
    name_zh: "巴拉圭",
    country_code: "PY",
    phone_perfix: "595",
  },
  {
    name_en: "Peru",
    name_zh: "秘鲁",
    country_code: "PE",
    phone_perfix: "51",
  },
  {
    name_en: "Philippines",
    name_zh: "菲律宾",
    country_code: "PH",
    phone_perfix: "6",
  },
  {
    name_en: "Poland",
    name_zh: "波兰",
    country_code: "PL",
    phone_perfix: "48",
  },
  {
    name_en: "French Polynesia",
    name_zh: "法属玻利尼西亚",
    country_code: "PF",
    phone_perfix: "689",
  },
  {
    name_en: "Portugal",
    name_zh: "葡萄牙",
    country_code: "PT",
    phone_perfix: "351",
  },
  {
    name_en: "Puerto Rico",
    name_zh: "波多黎各",
    country_code: "PR",
    phone_perfix: "1787",
  },
  {
    name_en: "Qatar",
    name_zh: "卡塔尔",
    country_code: "QA",
    phone_perfix: "974",
  },
  {
    name_en: "Reunion",
    name_zh: "留尼旺",
    country_code: "RE",
    phone_perfix: "262",
  },
  {
    name_en: "Romania",
    name_zh: "罗马尼亚",
    country_code: "RO",
    phone_perfix: "40",
  },
  {
    name_en: "Russia",
    name_zh: "俄罗斯",
    country_code: "RU",
    phone_perfix: "7",
  },
  {
    name_en: "Saint Lueia",
    name_zh: "圣卢西亚",
    country_code: "LC",
    phone_perfix: "1758",
  },
  {
    name_en: "Samoa Eastern",
    name_zh: "东萨摩亚（美）",
    country_code: "AS",
    phone_perfix: "684",
  },
  {
    name_en: "Samoa Western",
    name_zh: "西萨摩亚",
    country_code: "WS",
    phone_perfix: "685",
  },
  {
    name_en: "San Marino",
    name_zh: "圣马力诺",
    country_code: "SM",
    phone_perfix: "378",
  },
  {
    name_en: "Sao Tome and Principe",
    name_zh: "圣多美和普林西比",
    country_code: "ST",
    phone_perfix: "239",
  },
  {
    name_en: "Saudi Arabia",
    name_zh: "沙特阿拉伯",
    country_code: "SA",
    phone_perfix: "966",
  },
  {
    name_en: "Senegal",
    name_zh: "塞内加尔",
    country_code: "SN",
    phone_perfix: "221",
  },
  {
    name_en: "Seychelles",
    name_zh: "塞舌尔",
    country_code: "SC",
    phone_perfix: "248",
  },
  {
    name_en: "Sierra Leone",
    name_zh: "塞拉利昂",
    country_code: "SL",
    phone_perfix: "232",
  },
  {
    name_en: "Singapore",
    name_zh: "新加坡",
    country_code: "SG",
    phone_perfix: "65",
  },
  {
    name_en: "Slovakia",
    name_zh: "斯洛伐克",
    country_code: "SK",
    phone_perfix: "421",
  },
  {
    name_en: "Slovenia",
    name_zh: "斯洛文尼亚",
    country_code: "SI",
    phone_perfix: "386",
  },
  {
    name_en: "Solomon Is.",
    name_zh: "所罗门群岛",
    country_code: "SB",
    phone_perfix: "677",
  },
  {
    name_en: "Somali",
    name_zh: "索马里",
    country_code: "SO",
    phone_perfix: "252",
  },
  {
    name_en: "South Africa",
    name_zh: "南非",
    country_code: "ZA",
    phone_perfix: "27",
  },
  {
    name_en: "Spain",
    name_zh: "西班牙",
    country_code: "ES",
    phone_perfix: "34",
  },
  {
    name_en: "Sri Lanka",
    name_zh: "斯里兰卡",
    country_code: "LK",
    phone_perfix: "9",
  },
  {
    name_en: "St.Vincent",
    name_zh: "圣文森特",
    country_code: "VC",
    phone_perfix: "1784",
  },
  {
    name_en: "Sudan",
    name_zh: "苏丹",
    country_code: "SD",
    phone_perfix: "249",
  },
  {
    name_en: "South Sudan",
    name_zh: "南苏丹",
    country_code: "SS",
    phone_perfix: "211",
  },
  {
    name_en: "Suriname",
    name_zh: "苏里南",
    country_code: "SR",
    phone_perfix: "597 -1",
  },
  {
    name_en: "Swaziland",
    name_zh: "斯威士兰",
    country_code: "SZ",
    phone_perfix: "268",
  },
  {
    name_en: "Sweden",
    name_zh: "瑞典",
    country_code: "SE",
    phone_perfix: "46",
  },
  {
    name_en: "Switzerland",
    name_zh: "瑞士",
    country_code: "CH",
    phone_perfix: "41",
  },
  {
    name_en: "Syria",
    name_zh: "叙利亚",
    country_code: "SY",
    phone_perfix: "963",
  },
  {
    name_en: "Taiwan",
    name_zh: "台湾省",
    country_code: "TW",
    phone_perfix: "886",
  },
  {
    name_en: "Tajikstan",
    name_zh: "塔吉克斯坦",
    country_code: "TJ",
    phone_perfix: "992",
  },
  {
    name_en: "Tanzania",
    name_zh: "坦桑尼亚",
    country_code: "TZ",
    phone_perfix: "255",
  },
  {
    name_en: "Thailand",
    name_zh: "泰国",
    country_code: "TH",
    phone_perfix: "66",
  },
  {
    name_en: "Togo",
    name_zh: "多哥",
    country_code: "TG",
    phone_perfix: "228",
  },
  {
    name_en: "Tonga",
    name_zh: "汤加",
    country_code: "TO",
    phone_perfix: "676",
  },
  {
    name_en: "Trinidad and Tobago",
    name_zh: "特立尼达和多巴哥",
    country_code: "TT",
    phone_perfix: "1809",
  },
  {
    name_en: "Tunisia",
    name_zh: "突尼斯",
    country_code: "TN",
    phone_perfix: "216",
  },
  {
    name_en: "Turkey",
    name_zh: "土耳其",
    country_code: "TR",
    phone_perfix: "90",
  },
  {
    name_en: "Turkmenistan",
    name_zh: "土库曼斯坦",
    country_code: "TM",
    phone_perfix: "993",
  },
  {
    name_en: "Uganda",
    name_zh: "乌干达",
    country_code: "UG",
    phone_perfix: "256",
  },
  {
    name_en: "Ukraine",
    name_zh: "乌克兰",
    country_code: "UA",
    phone_perfix: "380",
  },
  {
    name_en: "United Arab Emirates",
    name_zh: "阿拉伯联合酋长国",
    country_code: "AE",
    phone_perfix: "971",
  },
  {
    name_en: "United Kiongdom",
    name_zh: "英国",
    country_code: "GB",
    phone_perfix: "44",
  },
  {
    name_en: "United States of America",
    name_zh: "美国",
    country_code: "US",
    phone_perfix: "1",
  },
  {
    name_en: "Uruguay",
    name_zh: "乌拉圭",
    country_code: "UY",
    phone_perfix: "598 -1",
  },
  {
    name_en: "Uzbekistan",
    name_zh: "乌兹别克斯坦",
    country_code: "UZ",
    phone_perfix: "233",
  },
  {
    name_en: "Venezuela",
    name_zh: "委内瑞拉",
    country_code: "VE",
    phone_perfix: "58 -1",
  },
  {
    name_en: "Vietnam",
    name_zh: "越南",
    country_code: "VN",
    phone_perfix: "84",
  },
  {
    name_en: "Yemen",
    name_zh: "也门",
    country_code: "YE",
    phone_perfix: "967",
  },
  {
    name_en: "Yugoslavia",
    name_zh: "南斯拉夫",
    country_code: "YU",
    phone_perfix: "381",
  },
  {
    name_en: "Zimbabwe",
    name_zh: "津巴布韦",
    country_code: "ZW",
    phone_perfix: "263",
  },
  {
    name_en: "Congo-kinshasa",
    name_zh: "刚果民主共和国",
    country_code: "CD",
    phone_perfix: "243",
  },
  {
    name_en: "Zambia",
    name_zh: "赞比亚",
    country_code: "ZM",
    phone_perfix: "260",
  },
];

export const getPhoneAreaCode = (value: any) => {
  let area_data: any = {};
  country_code.forEach((item: any) => {
    if (item.country_code === value) {
      area_data = item;
      return false;
    }
    return;
  });
  return area_data;
};
